// The one client-capable text representation helper. Contacts and Canvas use
// it to place structured JSON safely inside their HTML data attributes. This
// is reversible transport representation, not access control or secrecy.

function packText(value: string): string {
  if (typeof window === 'undefined') return Buffer.from(value, 'utf8').toString('base64')
  const bytes = new TextEncoder().encode(value)
  let binary = ''
  bytes.forEach(byte => { binary += String.fromCharCode(byte) })
  return window.btoa(binary)
}

function unpackText(value: string): string {
  if (typeof window === 'undefined') return Buffer.from(value, 'base64').toString('utf8')
  const binary = window.atob(value)
  const bytes = Uint8Array.from(binary, character => character.charCodeAt(0))
  return new TextDecoder().decode(bytes)
}

function packBytesUrl(bytes: Uint8Array): string {
  if (typeof window === 'undefined') return Buffer.from(bytes).toString('base64url')
  let binary = ''
  bytes.forEach(byte => { binary += String.fromCharCode(byte) })
  return window.btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
}

function unpackBytesUrl(value: string): Uint8Array {
  if (typeof window === 'undefined') return Uint8Array.from(Buffer.from(value, 'base64url'))
  const padded = value.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - value.length % 4) % 4)
  return Uint8Array.from(window.atob(padded), character => character.charCodeAt(0))
}

export const valueRepresentations = Object.freeze({
  packText,
  unpackText,
  packBytesUrl,
  unpackBytesUrl,
})
